export default __webpack_public_path__ + "static/GT-Super-Display-Medium-Italic-68d8950f26e8cc6355c76a67b46fd94d.woff";